import { RouteConfig } from 'vue-router'

import Campaign from './pages'

export const campaigns: RouteConfig = {
  component: Campaign,
  path: '/campaigns',
  name: 'campaigns'
}
